module.exports = __webpack_public_path__ + "static/desktop/img/production-mobile-calendar.ae26393c.png";